export default __webpack_public_path__ + "static/contribute_bg-ff70bf19c5075519608e17da6f18fbcf.png";